export default __webpack_public_path__ + "static/newsletter-4-4-f70557979ffd06a4919e0f803e78e56b.png";